import { BsSearch } from "react-icons/bs";
import SectionHeader from "../../components/commonUi/SectionHeader";
import { GoPlus } from "react-icons/go";
import TeamMemberCreateModal from "../../components/Modals/TeamMemberCreateModal";
import { useEffect, useState } from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";

import apiClient from "../../service/Axios";
import { ProgressSpinner } from "primereact/progressspinner";
import Card from "../../components/Card/Card";
import Pagination from "../../components/commonUi/Pagination";
import TeamMemberEditModal from "../../components/Modals/TeamMemberEditModal";

const TeamMemberPage = () => {
  const [memberData, setMemberData] = useState();
  const [visible, setVisible] = useState(false);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [loading, setLoding] = useState(false);
  const [activeMembers, setActiveMembers] = useState([]);
  const [inactiveMembers, setInactiveMembers] = useState([]);
  const [memberDataToEdit, setMemberDataToEdit] = useState(null);

  const openEditModal = (teamMemberData) => {
    setMemberDataToEdit(teamMemberData); // Set the member data to a state variable
    setVisibleEdit(true);
  };

  const [page, setPage] = useState(0);
  const handleEditClick = () => {
    setVisibleEdit(true);
  };
  const data = [
    {
      label: "All Member",
      value: "dashboard",
      no: memberData?.length,
      desc: (
        <div>
          {loading ? (
            <div className="flex justify-center items-center mt-20">
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="4"
                animationDuration=".5s"
              />
            </div>
          ) : (
            <div className="relative">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                {memberData?.slice(12 * page, 12 * (page + 1)).map((e, i) => {
                  return (
                    <Card
                      data={e}
                      key={i}
                      handleEditClick={() => {
                        // console.log("first", e);
                        openEditModal(e);
                      }}
                    />
                  );
                })}
              </div>
              {memberData && (
                <div className="fixed top-[205px] right-10">
                  <Pagination
                    length={memberData?.length}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      ),
    },
    {
      label: "Active Member",
      value: "profile",
      no: activeMembers?.length,
      desc: (
        <div className="relative">
          {loading ? (
            <div className="flex justify-center items-center mt-20">
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="4"
                animationDuration=".5s"
              />
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                {activeMembers
                  ?.slice(12 * page, 12 * (page + 1))
                  .map((e, i) => {
                    return (
                      <Card
                        data={e}
                        key={i}
                        handleEditClick={() => {
                          // console.log("first", e);
                          openEditModal(e);
                        }}
                      />
                    );
                  })}
              </div>
              {activeMembers && (
                <div className="fixed top-[205px] right-10">
                  <Pagination
                    length={activeMembers?.length}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              )}
            </>
          )}
        </div>
      ),
    },
    {
      label: "InActive Member",
      value: "settings",
      no: inactiveMembers?.length,
      desc: (
        <div className="relative">
          {loading ? (
            <div className="flex justify-center items-center mt-20">
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="4"
                animationDuration=".5s"
              />
            </div>
          ) : (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                {inactiveMembers
                  ?.slice(12 * page, 12 * (page + 1))
                  ?.map((e, i) => {
                    return (
                      <Card
                        data={e}
                        key={i}
                        handleEditClick={() => {
                          // console.log("first", e);
                          openEditModal(e);
                        }}
                      />
                    );
                  })}
              </div>
              {inactiveMembers && (
                <div className="fixed top-[205px] right-10">
                  <Pagination
                    length={inactiveMembers?.length}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              )}
            </>
          )}
        </div>
      ),
    },
  ];

  const memberdetailsListFunc = () => {
    setLoding(true);
    apiClient
      .get(`${process.env.REACT_APP_AUTHENTICATION_API}/user/list`)
      .then((res) => {
        const allMembers = res.data;
        setMemberData(res.data);
        // Filter active members
        const activeMembersFiltered = allMembers.filter(
          (member) => member.active === true
        );

        setActiveMembers(activeMembersFiltered);

        // Filter inactive members
        const inactiveMembersFiltered = allMembers.filter(
          (member) => member.active === false
        );

        setInactiveMembers(inactiveMembersFiltered);
        setLoding(false);
      });
  };
  useEffect(() => {
    memberdetailsListFunc();
  }, []);

  return (
    <div className="px-7">
      <div className="flex justify-between items-center">
        <SectionHeader
          title={"Team Members"}
          objective={"Create manage your team member."}
        />
        <div className="flex justify-center items-center gap-8 mt-4">
          <div className="relative">
            <BsSearch className="absolute top-2.5 left-3 text-gray-500" />
            <input
              type="name"
              id="search"
              placeholder="Search"
              name="search"
              className="pl-10 border border-gray-400 w-full rounded-[5px] h-9"
            />
          </div>

          <button
            className="hover:bg-[#161B22] bg-[#161b22d1] text-white font-normal py-2 px-4 rounded-md inline-flex items-center"
            onClick={() => setVisible(true)}>
            <GoPlus className="font-bold text-xl" />
            <span>Add Member</span>
          </button>
        </div>
      </div>
      <div className="mt-12">
        <Tabs value="dashboard">
          <div className="flex justify-between items-center">
            <TabsHeader>
              {data.map(({ label, value, no }) => (
                <Tab key={value} value={value}>
                  <div className="flex items-center gap-2 whitespace-nowrap">
                    {label}
                    <div className="avatar placeholder">
                      <div className="border-[1px] border-gray-400 text-neutral-content rounded-full w-5">
                        <span className="text-xs text-gray-700">{no}</span>
                      </div>
                    </div>
                  </div>
                </Tab>
              ))}
            </TabsHeader>
          </div>
          <TabsBody className="mt-3">
            {data.map(({ value, desc }) => (
              <TabPanel key={value} value={value}>
                {desc}
              </TabPanel>
            ))}
          </TabsBody>
        </Tabs>
      </div>
      <TeamMemberCreateModal
        visible={visible}
        setVisible={setVisible}
        memberdetailsListFunc={memberdetailsListFunc}
      />
      <TeamMemberEditModal
        visible={visibleEdit}
        setVisible={setVisibleEdit}
        memberData={memberDataToEdit}
      />
    </div>
  );
};

export default TeamMemberPage;
